import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '../services/date-format.service';

@Pipe({ name: 'appDate', standalone: true, pure: false })
export class AppDatePipe implements PipeTransform {
  constructor(private fmt: DateFormatService) {}

  transform(value: string | Date | null | undefined): string {
    return this.fmt.format(value);
  }
}
